import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { ShoppingListsView } from "@/features/shopping/components/shopping-lists-view";
import { PageContainer } from "@/components/ui/page-container";

function ShoppingPage() {
  return (
    <PageContainer maxWidth="3xl">
      <ShoppingListsView />
    </PageContainer>
  );
}

export const shoppingRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/shopping",
  component: ShoppingPage,
});
